<template>
  <BaseInfoBox :title="$t('event.location')" @open="handleOpen">
    <template #icon>
      <MapPinIcon class="w-6 h-6 shrink-0 fill-primary" />
    </template>

    <template #description>
      {{ venue.name }}
    </template>

    <template #default>
      <div class=""></div>
      <LeafletMap
        v-if="renderMap && venue.lat_lng"
        class="isolate bg-surface-grey overflow-hidden rounded-md mb-6 w-full aspect-video"
        :lat="lat"
        :lng="lng"
      />

      <div class="font-semibold text-text mb-1">
        {{ venue.name }}
      </div>
      <div class="text-text mb-6">
        {{ venue.address }},
        {{ venue.zip }} {{ venue.city }}
      </div>
      <a
        :href="`https://maps.google.com/maps?t=m&q=${encodeURIComponent(`${venue.address}, ${venue.zip} ${venue.city}`)}`"
        target="_blank"
        class="underline hover:opacity-80"
      >
        {{ $t('event.open_in_google_maps') }}
      </a>
    </template>
  </BaseInfoBox>
</template>

<script setup lang="ts">
  import { computed, ref, watch } from 'vue';

  import type { Venue } from '@/types';

  import MapPinIcon from '../icons/MapPinIcon.vue';
  import BaseInfoBox from '../ui/BaseInfoBox.vue';
  import LeafletMap from './LeafletMap.vue';

  const props = defineProps<{ venue: Venue }>();

  let lat = computed(() => Number(props.venue.lat_lng?.split(',')[0] ?? 0));
  let lng = computed(() => Number(props.venue.lat_lng?.split(',')[1] ?? 0));

  watch(
    () => props.venue,
    () => {
      lat = computed(() => Number(props.venue.lat_lng?.split(',')[0] ?? 0));
      lng = computed(() => Number(props.venue.lat_lng?.split(',')[1] ?? 0));
    }
  );

  const open = ref(false);
  const renderMap = ref(false);
  function handleOpen(val: boolean) {
    if (!renderMap.value) {
      renderMap.value = true;
    }

    open.value = val;
  }
</script>
